/* unplugin-vue-components disabled */import script from "./searchProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./searchProducts.vue?vue&type=script&lang=ts&setup=true"

import "./searchProducts.vue?vue&type=style&index=0&id=03b44fb3&lang=scss&scoped=true"
import "./searchProducts.vue?vue&type=style&index=1&id=03b44fb3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b44fb3"]])

export default __exports__